import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  searchQuery: string
}

const EmptyRemoteConfigsComponent = ({ searchQuery }: Props) => {
  const trimmedSearch = searchQuery.trim()

  return (
    <div data-testid="remote-config-empty" css={tw`flex h-full w-full items-center justify-center`}>
      <Typography variant="body2" css={tw`text-shades-500`}>
        {trimmedSearch === '' ? 'No keys yet.' : `No keys match "${trimmedSearch}".`}
      </Typography>
    </div>
  )
}

export const EmptyRemoteConfigs = memo(EmptyRemoteConfigsComponent)
